import './EventDetails.scss';
import { useTranslation } from "react-i18next";
import AppTabs from '../AppTabs/AppTabs';
import ClassicEventView from '../ClassicEventView/ClassicEventView';
import EnhancedEventView from '../EnhancedEventView/EnhancedEventView';

const EventDetails = ({
  actualView,   
  eventList,  
  handleTabChange,
  handleViewAllClick,  
  numberOfEvents, 
  selectedEventIndex,
  setSelectedEventIndex,
  tabValue,
  viewAll,
  noData,
  }) => {
    
  const { t } = useTranslation();

  const getTabLabels = () => {
    const tabLabels = [t('myBlockMonth.enhancedView'), t('myBlockMonth.classicView')];
    return tabLabels;
  }

  const getTabElements = () => {
    const EnhancedEventViewComponent = <EnhancedEventView
                                          actualView={actualView}
                                          events={eventList}
                                          handleViewAllClick={handleViewAllClick}
                                          numberOfEvents = {numberOfEvents}
                                          selectedEventIndex={selectedEventIndex}
                                          setSelectedEventIndex={setSelectedEventIndex}
                                          viewAll={viewAll}
                                          noData={noData}
                                        />

    const ClassicEventViewComponent = <ClassicEventView
                                        actualView={actualView}
                                        events={eventList}
                                        handleViewAllClick={handleViewAllClick}
                                        numberOfEvents = {numberOfEvents}
                                        selectedEventIndex={selectedEventIndex}
                                        setSelectedEventIndex={setSelectedEventIndex}
                                        viewAll={viewAll}
                                        noData={noData}
                                      />

    return [EnhancedEventViewComponent, ClassicEventViewComponent];
  }

  return (
    <AppTabs 
      handleTabChange={handleTabChange}
      tabElements={getTabElements()}
      tabLabels={getTabLabels()}
      tabValue={tabValue}
    />
  );
}

export default EventDetails;
